<div class="form-section credentials-section w-100 mt-2 p-0" [formGroup]="form">
  <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
    <div class="d-flex align-items-center p-1">
      <img
        class="section-image"
        src="../../assets/icon/unlocked-outlined-white.svg"
        alt="credentials"
        style="width: 24px; height: 24px"
        />
    </div>
    <div class="form-title-text-container">
      <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
        {{ 'USER_FORM.CREDENTIALS' | translate }}
      </p>
    </div>
  </div>

  <div class="input-wrapper">
    <label for="password">{{ 'USER_FORM.PASSWORD' | translate }}*</label>
    <div class="password-input-container">
      <app-icam-input
        label="{{ 'USER_FORM.PASSWORD' | translate }}"
        inputId="password"
        formControlName="password"
        [isSlim]="true"
        [inputType]="'text'"
        [ngClass]="isLight ? 'light' : 'dark'"
        />
    </div>
    @if (form.get('password')?.invalid && (form.get('password')?.touched || form.get('password')?.dirty)) {
      <div
        class="invalid-feedback d-block"
        >
        @if (form.get('password')?.hasError('required')) {
          <span>{{ 'USER_FORM.REQUIRED_FIELD' | translate }}</span>
        }
        @if (form.get('password')?.hasError('minlength')) {
          <span>{{ 'USER_FORM.PASSWORD_TOO_SHORT' | translate }}</span>
        }
      </div>
    }
  </div>

  <div class="template-mail-container">
    <hr class="my-4" [ngClass]="isLight ? 'light' : 'dark'" />

    <div class="input-wrapper mb-2">
      <label for="templateLanguage">{{ 'USER_FORM.TEMPLATE_LANGUAGE' | translate }}*</label>
      <select
        id="templateLanguage"
        formControlName="templateLanguage"
        class="form-select filter-select rounded-0 fw-bold mt-1"
        [ngClass]="isLight ? 'light' : 'dark'"
        [class.is-invalid]="form.get('templateLanguage')?.invalid && form.get('templateLanguage')?.touched"
        [disabled]="isLoadingTemplate"
        (change)="onTemplateLanguageChange()"
        >
        <option value="">{{ 'COMMON.CHOOSE_VALUE' | translate }}</option>
        @for (language of availableLanguages; track language) {
          <option [value]="language.lang">
            {{ language.lang?.toUpperCase() }}
          </option>
        }
      </select>
      @if (
        form.get('templateLanguage')?.invalid &&
        (form.get('templateLanguage')?.touched || form.get('templateLanguage')?.dirty)
        ) {
        <div
          class="invalid-feedback"
          >
          {{ 'USER_FORM.REQUIRED_FIELD' | translate }}
        </div>
      }
    </div>

    @if (isLoadingTemplate) {
      <div class="text-center my-4 py-5">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-3 mb-0">{{ 'COMMON.LOADING' | translate }}</p>
      </div>
    }

    @if (!isLoadingTemplate) {
      <div class="input-wrapper mb-2">
        <label for="welcomeSubject">{{ 'USER_FORM.TEMPLATE_MAIL_SUBJECT' | translate }}</label>
        <app-icam-input
          label="{{ 'USER_FORM.TEMPLATE_MAIL_SUBJECT' | translate }}"
          inputId="welcomeSubject"
          formControlName="welcomeSubject"
          [isSlim]="true"
          [ngClass]="isLight ? 'light' : 'dark'"
        ></app-icam-input>
      </div>
      <div class="input-wrapper mb-2">
        <label for="templateMail">{{ 'USER_FORM.TEMPLATE_MAIL' | translate }}</label>
        <textarea
          id="templateMail"
          formControlName="templateMail"
          class="form-control"
          rows="20"
          style="max-height: 600px"
          [ngClass]="isLight ? 'light' : 'dark'"
        ></textarea>
      </div>
    }
  </div>
</div>
